import { useEffect } from "react";
import Message from "../components/Message";

export default function IntegrationError() {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const integrationId = params.get("integrationId");
    }, []);

    return (
        <div className="p-4">
            <Message error>
                Integration failed to connect. Please try again.
            </Message>
        </div>
    );
}
